var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 13.1135V19.6923C23 20.3043 22.7695 20.8913 22.3593 21.3241C21.9491 21.7569 21.3927 22 20.8125 22H11.1875C10.6073 22 10.0509 21.7569 9.6407 21.3241C9.23047 20.8913 9 20.3043 9 19.6923V13.1135L15.7778 17.3209C15.8451 17.3628 15.9218 17.3849 16 17.3849C16.0782 17.3849 16.1549 17.3628 16.2222 17.3209L23 13.1135ZM20.8125 10C21.3508 9.99991 21.8701 10.2092 22.2713 10.5878C22.6725 10.9663 22.9272 11.4877 22.9869 12.052L16 16.3877L9.01313 12.052C9.07276 11.4877 9.32753 10.9663 9.7287 10.5878C10.1299 10.2092 10.6492 9.99991 11.1875 10H20.8125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.a6e0f234e6546d3b73fe6a87e8eab506.svg";
export { ForwardRef as ReactComponent };